import { LicenseValidityChooserRelativeDateConstraint } from './license-validity-chooser-relative-date-constraint';

export interface LicenseValidityChooserDateConstraints<T = Date> {
  allowedDateCronExpression: string;
  enforceDateInFuture: boolean;
  notBeforeRelativeDate: LicenseValidityChooserRelativeDateConstraint | null;
  notBeforeDate: T | null;
  notAfterRelativeDate: LicenseValidityChooserRelativeDateConstraint | null;
  notAfterDate: T | null;
}
